// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2le1l","col":"styles_col__2wdC3"};